import { operationsState, setOperationsStateById } from '../OperationsContext';

export const updateOperationsContext =
  (setStateById: setOperationsStateById) => (newstate: Partial<typeof operationsState>) => {
    setStateById('UPDATE_CONTEXT', (s) => ({
      ...s,
      ...newstate,
    }));
  };
